module.exports = __webpack_public_path__ + "img/video-simply-3.a43440eb.png";